export default "__VITE_ASSET__Ce338KYM__"